const balancesheet = { data: [], loading: true };
export const GetBalanceSheet = (state = balancesheet, action) => {
  switch (action.type) {
    case "get_allbalancesheet":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
